import {CtModelRouteData} from "@ctsolution/ct-framework";

export const UserInfoWorkDataRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("UserInfoWorkData");
